import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import PricingSection from "./components/PricingSection";
import ApplicationSection from "./components/ApplicationSection";
import AboutSection from "./components/AboutSection";
import ConsultationSection from "./components/ConsultationSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <Navbar />
      <main>
        <HeroSection />
        <PricingSection />
        <ApplicationSection />
        <AboutSection />
        <ConsultationSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
